import type { Deal } from '@/types'
const MARKER = import.meta.env.VITE_TRAVELPAYOUTS_MARKER || '729556'

export function buildAffiliateLink(deal: Deal): string {
  if (deal.network === 'direct') return deal.baseUrl
  try {
    const url = new URL(deal.baseUrl)
    url.searchParams.set('marker', MARKER)
    url.searchParams.set('utm_source', 'sanctum_imaginarium')
    url.searchParams.set('utm_medium', 'affiliate')
    url.searchParams.set('utm_campaign', `sanctum_${deal.category}`)
    return url.toString()
  } catch { return deal.baseUrl }
}

export function openDeal(deal: Deal, destination: string): void {
  const event = { dealTitle: deal.title, network: deal.network, destination, timestamp: new Date().toISOString() }
  const log = JSON.parse(sessionStorage.getItem('sanctum_affiliate_clicks') || '[]')
  log.push(event); sessionStorage.setItem('sanctum_affiliate_clicks', JSON.stringify(log))
  window.open(buildAffiliateLink(deal), '_blank', 'noopener,noreferrer')
}

export const NETWORK_LABELS: Record<string, string> = {
  skyscanner: 'Skyscanner', booking_com: 'Booking.com', viator: 'Viator',
  get_your_guide: 'GetYourGuide', klook: 'Klook', airbnb: 'Airbnb', direct: 'Direct',
}
